import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import {
  getCabBookings,
  deleteCabBooking,
  rejectCabBooking,
} from "@/services/api/cabBookings"

export const useFetchCabBookings = (offset, limit, search, order_status) => {
  return useQuery({
    queryKey: ["cabBookings", offset, limit, search, order_status],
    queryFn: async () => {
      const res = await getCabBookings({ offset, limit, search, order_status })
      return res.data
    },
    select: (response) => ({
      cabBookings: response.data.orders,
      pagination: {
        total: response.data.total,
        totalPages: Math.ceil(response.data.total / limit),
      },
    }),
    staleTime: 5 * 60 * 1000,
  })
}

export const useDeleteCabBooking = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (orderId) => deleteCabBooking(orderId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cabBookings"] })
    },
  })
}

export const useRejectCabBooking = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (orderId) => rejectCabBooking(orderId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cabBookings"] })
    },
  })
}
